var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    fill: "#FEFEFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    stroke: "#64696C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6587 11.5966C19.2035 11.1345 18.4638 11.1345 18.0087 11.5966L13.8087 15.8782L11.9913 14.0256C11.7637 13.7935 11.4655 13.6776 11.1672 13.6776C10.8672 13.6776 10.569 13.7935 10.3414 14.0256C9.88622 14.4895 9.88622 15.2436 10.3414 15.7076L12.9844 18.402C13.2051 18.6252 13.4965 18.75 13.8085 18.75C14.1205 18.75 14.4136 18.6252 14.6344 18.402L19.6585 13.2785C20.1138 12.8163 20.1138 12.0606 19.6587 11.5966Z",
    fill: "#171717"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/Completed.f5898dc09877740e87dae75861d1ab12.svg";
export { ForwardRef as ReactComponent };